export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** Input type for dynamic zone Sections of GenericPage */
  GenericPageSectionsDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type Booking = {
  __typename?: 'Booking';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Voucher?: Maybe<Voucher>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  HasAcceptedIndemnity?: Maybe<Scalars['Boolean']>;
  Spectator?: Maybe<ComponentEventSpectator>;
  Course?: Maybe<Course>;
  Customer?: Maybe<Customer>;
  r_customerFullName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
  r_courseDate?: Maybe<Scalars['Date']>;
  Notes?: Maybe<Scalars['String']>;
};

export type BookingAggregator = {
  __typename?: 'BookingAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BookingConnection = {
  __typename?: 'BookingConnection';
  values?: Maybe<Array<Maybe<Booking>>>;
  groupBy?: Maybe<BookingGroupBy>;
  aggregate?: Maybe<BookingAggregator>;
};

export type BookingConnection_id = {
  __typename?: 'BookingConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCourse = {
  __typename?: 'BookingConnectionCourse';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCreatedAt = {
  __typename?: 'BookingConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionCustomer = {
  __typename?: 'BookingConnectionCustomer';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionHasAcceptedIndemnity = {
  __typename?: 'BookingConnectionHasAcceptedIndemnity';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionHasPaid = {
  __typename?: 'BookingConnectionHasPaid';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionId = {
  __typename?: 'BookingConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionNotes = {
  __typename?: 'BookingConnectionNotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionR_courseDate = {
  __typename?: 'BookingConnectionR_courseDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionR_courseTypeName = {
  __typename?: 'BookingConnectionR_courseTypeName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionR_customerFullName = {
  __typename?: 'BookingConnectionR_customerFullName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionSpectator = {
  __typename?: 'BookingConnectionSpectator';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionUpdatedAt = {
  __typename?: 'BookingConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingConnectionVoucher = {
  __typename?: 'BookingConnectionVoucher';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookingConnection>;
};

export type BookingGroupBy = {
  __typename?: 'BookingGroupBy';
  id?: Maybe<Array<Maybe<BookingConnectionId>>>;
  _id?: Maybe<Array<Maybe<BookingConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<BookingConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<BookingConnectionUpdatedAt>>>;
  Voucher?: Maybe<Array<Maybe<BookingConnectionVoucher>>>;
  HasPaid?: Maybe<Array<Maybe<BookingConnectionHasPaid>>>;
  HasAcceptedIndemnity?: Maybe<Array<Maybe<BookingConnectionHasAcceptedIndemnity>>>;
  Spectator?: Maybe<Array<Maybe<BookingConnectionSpectator>>>;
  Course?: Maybe<Array<Maybe<BookingConnectionCourse>>>;
  Customer?: Maybe<Array<Maybe<BookingConnectionCustomer>>>;
  r_customerFullName?: Maybe<Array<Maybe<BookingConnectionR_customerFullName>>>;
  r_courseTypeName?: Maybe<Array<Maybe<BookingConnectionR_courseTypeName>>>;
  r_courseDate?: Maybe<Array<Maybe<BookingConnectionR_courseDate>>>;
  Notes?: Maybe<Array<Maybe<BookingConnectionNotes>>>;
};

export type BookingInput = {
  Voucher?: Maybe<Scalars['ID']>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  HasAcceptedIndemnity?: Maybe<Scalars['Boolean']>;
  Spectator?: Maybe<ComponentEventSpectatorInput>;
  Course?: Maybe<Scalars['ID']>;
  Customer?: Maybe<Scalars['ID']>;
  r_customerFullName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
  r_courseDate?: Maybe<Scalars['Date']>;
  Notes?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentContentImageOrVideo = {
  __typename?: 'ComponentContentImageOrVideo';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Image?: Maybe<UploadFile>;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type ComponentContentImageOrVideoInput = {
  Image?: Maybe<Scalars['ID']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type ComponentContentLinkBlock = {
  __typename?: 'ComponentContentLinkBlock';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Description?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Image?: Maybe<UploadFile>;
  Link?: Maybe<ComponentNavigationLink>;
};

export type ComponentContentLinkBlockInput = {
  Description?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  Link?: Maybe<ComponentNavigationLinkInput>;
};

export type ComponentContentMarkdown = {
  __typename?: 'ComponentContentMarkdown';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Content?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
};

export type ComponentContentMarkdownInput = {
  Content?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
};

export type ComponentContentSlider = {
  __typename?: 'ComponentContentSlider';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Image?: Maybe<UploadFile>;
  Title?: Maybe<ComponentContentTitle>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLink>;
  CTASecondary?: Maybe<ComponentNavigationLink>;
  EventDate?: Maybe<Scalars['Date']>;
  Position?: Maybe<ENUM_COMPONENTCONTENTSLIDER_POSITION>;
  CourseType?: Maybe<CourseType>;
};

export type ComponentContentSliderInput = {
  Image?: Maybe<Scalars['ID']>;
  Title?: Maybe<ComponentContentTitleInput>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLinkInput>;
  CTASecondary?: Maybe<ComponentNavigationLinkInput>;
  EventDate?: Maybe<Scalars['Date']>;
  Position?: Maybe<ENUM_COMPONENTCONTENTSLIDER_POSITION>;
  CourseType?: Maybe<Scalars['ID']>;
};

export type ComponentContentTab = {
  __typename?: 'ComponentContentTab';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Image?: Maybe<UploadFile>;
  Paragraph?: Maybe<Scalars['String']>;
  Layout: ENUM_COMPONENTCONTENTTAB_LAYOUT;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type ComponentContentTabInput = {
  Title?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  Image?: Maybe<Scalars['ID']>;
  Paragraph?: Maybe<Scalars['String']>;
  Layout?: Maybe<ENUM_COMPONENTCONTENTTAB_LAYOUT>;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type ComponentContentTable = {
  __typename?: 'ComponentContentTable';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
};

export type ComponentContentTableCell = {
  __typename?: 'ComponentContentTableCell';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Text?: Maybe<Scalars['String']>;
};

export type ComponentContentTableCellInput = {
  Text?: Maybe<Scalars['String']>;
};

export type ComponentContentTableInput = {
  Title?: Maybe<ComponentContentTitleInput>;
};

export type ComponentContentTableRow = {
  __typename?: 'ComponentContentTableRow';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  TableCell?: Maybe<Array<Maybe<ComponentContentTableCell>>>;
};

export type ComponentContentTableRowInput = {
  TableCell?: Maybe<Array<Maybe<ComponentContentTableCellInput>>>;
};

export type ComponentContentTitle = {
  __typename?: 'ComponentContentTitle';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Text?: Maybe<Scalars['String']>;
  Subtext?: Maybe<Scalars['String']>;
  HeadingSize?: Maybe<ENUM_COMPONENTCONTENTTITLE_HEADINGSIZE>;
};

export type ComponentContentTitleInput = {
  Text?: Maybe<Scalars['String']>;
  Subtext?: Maybe<Scalars['String']>;
  HeadingSize?: Maybe<ENUM_COMPONENTCONTENTTITLE_HEADINGSIZE>;
};

export type ComponentEventSchedule = {
  __typename?: 'ComponentEventSchedule';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Time?: Maybe<Scalars['Time']>;
  Description?: Maybe<Scalars['String']>;
};

export type ComponentEventScheduleInput = {
  Time?: Maybe<Scalars['Time']>;
  Description?: Maybe<Scalars['String']>;
};

export type ComponentEventSpectator = {
  __typename?: 'ComponentEventSpectator';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Name?: Maybe<Scalars['String']>;
  Dietary?: Maybe<Scalars['String']>;
};

export type ComponentEventSpectatorInput = {
  Name?: Maybe<Scalars['String']>;
  Dietary?: Maybe<Scalars['String']>;
};

export type ComponentLayoutAvailableCourseListing = {
  __typename?: 'ComponentLayoutAvailableCourseListing';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutAvailableCourseListingInput = {
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutBookingForm = {
  __typename?: 'ComponentLayoutBookingForm';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  CourseType?: Maybe<CourseType>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutBookingFormInput = {
  CourseType?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutContactForm = {
  __typename?: 'ComponentLayoutContactForm';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutContactFormInput = {
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutCourseInformation = {
  __typename?: 'ComponentLayoutCourseInformation';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  CourseType?: Maybe<CourseType>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutCourseInformationInput = {
  CourseType?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutCtaGroup = {
  __typename?: 'ComponentLayoutCtaGroup';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  CtaButtons?: Maybe<Array<Maybe<ComponentNavigationLink>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutCtaGroupInput = {
  CtaButtons?: Maybe<Array<Maybe<ComponentNavigationLinkInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutDiagonalSlider = {
  __typename?: 'ComponentLayoutDiagonalSlider';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Image?: Maybe<UploadFile>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLink>;
  CTASecondary?: Maybe<ComponentNavigationLink>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutDiagonalSliderInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Image?: Maybe<Scalars['ID']>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLinkInput>;
  CTASecondary?: Maybe<ComponentNavigationLinkInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutImageGrid = {
  __typename?: 'ComponentLayoutImageGrid';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Size?: Maybe<ComponentLayoutSectionSize>;
  AnchorId?: Maybe<Scalars['String']>;
  Images?: Maybe<Array<Maybe<UploadFile>>>;
};


export type ComponentLayoutImageGridImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentLayoutImageGridInput = {
  Images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Size?: Maybe<ComponentLayoutSectionSizeInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutImageGroup = {
  __typename?: 'ComponentLayoutImageGroup';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  FirstImageOrVideo?: Maybe<ComponentContentImageOrVideo>;
  SecondImageOrVideo?: Maybe<ComponentContentImageOrVideo>;
  ThirdImageOrVideo?: Maybe<ComponentContentImageOrVideo>;
  FourthImageOrVideo?: Maybe<ComponentContentImageOrVideo>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutImageGroupInput = {
  FirstImageOrVideo?: Maybe<ComponentContentImageOrVideoInput>;
  SecondImageOrVideo?: Maybe<ComponentContentImageOrVideoInput>;
  ThirdImageOrVideo?: Maybe<ComponentContentImageOrVideoInput>;
  FourthImageOrVideo?: Maybe<ComponentContentImageOrVideoInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutLinkBlockGroup = {
  __typename?: 'ComponentLayoutLinkBlockGroup';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  SectionSize?: Maybe<ComponentLayoutSectionSize>;
  Links?: Maybe<Array<Maybe<ComponentContentLinkBlock>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutLinkBlockGroupInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  SectionSize?: Maybe<ComponentLayoutSectionSizeInput>;
  Links?: Maybe<Array<Maybe<ComponentContentLinkBlockInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutModelOverview = {
  __typename?: 'ComponentLayoutModelOverview';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutModelOverviewInput = {
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutParagraph = {
  __typename?: 'ComponentLayoutParagraph';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLink>;
  CTASecondary?: Maybe<ComponentNavigationLink>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutParagraphInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLinkInput>;
  CTASecondary?: Maybe<ComponentNavigationLinkInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutSectionSize = {
  __typename?: 'ComponentLayoutSectionSize';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  DesktopSpan?: Maybe<Scalars['Int']>;
  TabletSpan?: Maybe<Scalars['Int']>;
  MobileSpan?: Maybe<Scalars['Int']>;
};

export type ComponentLayoutSectionSizeInput = {
  DesktopSpan?: Maybe<Scalars['Int']>;
  TabletSpan?: Maybe<Scalars['Int']>;
  MobileSpan?: Maybe<Scalars['Int']>;
};

export type ComponentLayoutSliderGroup = {
  __typename?: 'ComponentLayoutSliderGroup';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Sliders?: Maybe<Array<Maybe<ComponentContentSlider>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutSliderGroupInput = {
  Sliders?: Maybe<Array<Maybe<ComponentContentSliderInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutTabInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Tabs?: Maybe<Array<Maybe<ComponentContentTabInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutTabs = {
  __typename?: 'ComponentLayoutTabs';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Tabs?: Maybe<Array<Maybe<ComponentContentTab>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutTwoColumnImageFirst = {
  __typename?: 'ComponentLayoutTwoColumnImageFirst';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Image?: Maybe<UploadFile>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLink>;
  CTASecondary?: Maybe<ComponentNavigationLink>;
  ImageFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNIMAGEFIRST_IMAGEFIRSTIMAGESIZE>;
  HasSpacing: Scalars['Boolean'];
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<CourseType>>>;
};


export type ComponentLayoutTwoColumnImageFirstcourse_typesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentLayoutTwoColumnImageFirstInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Image?: Maybe<Scalars['ID']>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<ComponentNavigationLinkInput>;
  CTASecondary?: Maybe<ComponentNavigationLinkInput>;
  ImageFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNIMAGEFIRST_IMAGEFIRSTIMAGESIZE>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentLayoutTwoColumnTextFirst = {
  __typename?: 'ComponentLayoutTwoColumnTextFirst';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Text?: Maybe<Scalars['String']>;
  Image?: Maybe<UploadFile>;
  CTAPrimary?: Maybe<ComponentNavigationLink>;
  CTASecondary?: Maybe<ComponentNavigationLink>;
  TextFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNTEXTFIRST_TEXTFIRSTIMAGESIZE>;
  HasSpacing: Scalars['Boolean'];
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<CourseType>>>;
};


export type ComponentLayoutTwoColumnTextFirstcourse_typesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ComponentLayoutTwoColumnTextFirstInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Text?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  CTAPrimary?: Maybe<ComponentNavigationLinkInput>;
  CTASecondary?: Maybe<ComponentNavigationLinkInput>;
  TextFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNTEXTFIRST_TEXTFIRSTIMAGESIZE>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ComponentLayoutTwoColumnTextOnly = {
  __typename?: 'ComponentLayoutTwoColumnTextOnly';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Title?: Maybe<ComponentContentTitle>;
  Text1?: Maybe<Scalars['String']>;
  Text2?: Maybe<Scalars['String']>;
  HasSpacing: Scalars['Boolean'];
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutTwoColumnTextOnlyInput = {
  Title?: Maybe<ComponentContentTitleInput>;
  Text1?: Maybe<Scalars['String']>;
  Text2?: Maybe<Scalars['String']>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVehicleOverview = {
  __typename?: 'ComponentLayoutVehicleOverview';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  Vehicle?: Maybe<Vehicle>;
  Overview?: Maybe<Scalars['String']>;
  Title?: Maybe<ComponentContentTitle>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVehicleOverviewInput = {
  Vehicle?: Maybe<Scalars['ID']>;
  Overview?: Maybe<Scalars['String']>;
  Title?: Maybe<ComponentContentTitleInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVehicleSpecificationsCounter = {
  __typename?: 'ComponentLayoutVehicleSpecificationsCounter';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  vehicle?: Maybe<Vehicle>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVehicleSpecificationsCounterInput = {
  vehicle?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVoucherForm = {
  __typename?: 'ComponentLayoutVoucherForm';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentLayoutVoucherFormInput = {
  AnchorId?: Maybe<Scalars['String']>;
};

export type ComponentNavigationLink = {
  __typename?: 'ComponentNavigationLink';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  IsActive?: Maybe<Scalars['Boolean']>;
  TextDesktop?: Maybe<Scalars['String']>;
  TextMobile?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  ClickClassDesktop?: Maybe<Scalars['String']>;
  ClickClassMobile?: Maybe<Scalars['String']>;
};

export type ComponentNavigationLinkInput = {
  IsActive?: Maybe<Scalars['Boolean']>;
  TextDesktop?: Maybe<Scalars['String']>;
  TextMobile?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  ClickClassDesktop?: Maybe<Scalars['String']>;
  ClickClassMobile?: Maybe<Scalars['String']>;
};

export type Course = {
  __typename?: 'Course';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Date?: Maybe<Scalars['Date']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  RegistrationOpen?: Maybe<Scalars['Date']>;
  RegistrationClose?: Maybe<Scalars['Date']>;
  CourseType?: Maybe<CourseType>;
  r_totalBookings?: Maybe<Scalars['Int']>;
  TotalSpaces?: Maybe<Scalars['Int']>;
  r_availableSpaces?: Maybe<Scalars['Int']>;
  CorporateEvent?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  r_courseType?: Maybe<Scalars['String']>;
  Bookings?: Maybe<Array<Maybe<Booking>>>;
};


export type CourseBookingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CourseAggregator = {
  __typename?: 'CourseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CourseAggregatorSum>;
  avg?: Maybe<CourseAggregatorAvg>;
  min?: Maybe<CourseAggregatorMin>;
  max?: Maybe<CourseAggregatorMax>;
};

export type CourseAggregatorAvg = {
  __typename?: 'CourseAggregatorAvg';
  r_totalBookings?: Maybe<Scalars['Float']>;
  TotalSpaces?: Maybe<Scalars['Float']>;
  r_availableSpaces?: Maybe<Scalars['Float']>;
};

export type CourseAggregatorMax = {
  __typename?: 'CourseAggregatorMax';
  r_totalBookings?: Maybe<Scalars['Float']>;
  TotalSpaces?: Maybe<Scalars['Float']>;
  r_availableSpaces?: Maybe<Scalars['Float']>;
};

export type CourseAggregatorMin = {
  __typename?: 'CourseAggregatorMin';
  r_totalBookings?: Maybe<Scalars['Float']>;
  TotalSpaces?: Maybe<Scalars['Float']>;
  r_availableSpaces?: Maybe<Scalars['Float']>;
};

export type CourseAggregatorSum = {
  __typename?: 'CourseAggregatorSum';
  r_totalBookings?: Maybe<Scalars['Float']>;
  TotalSpaces?: Maybe<Scalars['Float']>;
  r_availableSpaces?: Maybe<Scalars['Float']>;
};

export type CourseConnection = {
  __typename?: 'CourseConnection';
  values?: Maybe<Array<Maybe<Course>>>;
  groupBy?: Maybe<CourseGroupBy>;
  aggregate?: Maybe<CourseAggregator>;
};

export type CourseConnection_id = {
  __typename?: 'CourseConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionCorporateEvent = {
  __typename?: 'CourseConnectionCorporateEvent';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionCourseType = {
  __typename?: 'CourseConnectionCourseType';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionCreatedAt = {
  __typename?: 'CourseConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionDate = {
  __typename?: 'CourseConnectionDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionId = {
  __typename?: 'CourseConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionIsActive = {
  __typename?: 'CourseConnectionIsActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionNotes = {
  __typename?: 'CourseConnectionNotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionR_availableSpaces = {
  __typename?: 'CourseConnectionR_availableSpaces';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionR_courseType = {
  __typename?: 'CourseConnectionR_courseType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionR_totalBookings = {
  __typename?: 'CourseConnectionR_totalBookings';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionRegistrationClose = {
  __typename?: 'CourseConnectionRegistrationClose';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionRegistrationOpen = {
  __typename?: 'CourseConnectionRegistrationOpen';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionTotalSpaces = {
  __typename?: 'CourseConnectionTotalSpaces';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseConnectionUpdatedAt = {
  __typename?: 'CourseConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CourseConnection>;
};

export type CourseGroupBy = {
  __typename?: 'CourseGroupBy';
  id?: Maybe<Array<Maybe<CourseConnectionId>>>;
  _id?: Maybe<Array<Maybe<CourseConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<CourseConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CourseConnectionUpdatedAt>>>;
  Date?: Maybe<Array<Maybe<CourseConnectionDate>>>;
  IsActive?: Maybe<Array<Maybe<CourseConnectionIsActive>>>;
  RegistrationOpen?: Maybe<Array<Maybe<CourseConnectionRegistrationOpen>>>;
  RegistrationClose?: Maybe<Array<Maybe<CourseConnectionRegistrationClose>>>;
  CourseType?: Maybe<Array<Maybe<CourseConnectionCourseType>>>;
  r_totalBookings?: Maybe<Array<Maybe<CourseConnectionR_totalBookings>>>;
  TotalSpaces?: Maybe<Array<Maybe<CourseConnectionTotalSpaces>>>;
  r_availableSpaces?: Maybe<Array<Maybe<CourseConnectionR_availableSpaces>>>;
  CorporateEvent?: Maybe<Array<Maybe<CourseConnectionCorporateEvent>>>;
  Notes?: Maybe<Array<Maybe<CourseConnectionNotes>>>;
  r_courseType?: Maybe<Array<Maybe<CourseConnectionR_courseType>>>;
};

export type CourseInput = {
  Date?: Maybe<Scalars['Date']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  RegistrationOpen?: Maybe<Scalars['Date']>;
  RegistrationClose?: Maybe<Scalars['Date']>;
  CourseType?: Maybe<Scalars['ID']>;
  Bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  r_totalBookings?: Maybe<Scalars['Int']>;
  TotalSpaces?: Maybe<Scalars['Int']>;
  r_availableSpaces?: Maybe<Scalars['Int']>;
  CorporateEvent?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  r_courseType?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CourseType = {
  __typename?: 'CourseType';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Name?: Maybe<Scalars['String']>;
  Price?: Maybe<Scalars['Float']>;
  Description?: Maybe<Scalars['String']>;
  Venue?: Maybe<Scalars['String']>;
  Agenda?: Maybe<Array<Maybe<ComponentEventSchedule>>>;
  Duration?: Maybe<ENUM_COURSETYPE_DURATION>;
  ShortDescription?: Maybe<Scalars['String']>;
  Image?: Maybe<UploadFile>;
  Slug?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  CourseLogo?: Maybe<UploadFile>;
  CourseLogoMainSlider?: Maybe<UploadFile>;
  Courses?: Maybe<Array<Maybe<Course>>>;
  Vouchers?: Maybe<Array<Maybe<Voucher>>>;
};


export type CourseTypeCoursesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CourseTypeVouchersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CourseTypeAggregator = {
  __typename?: 'CourseTypeAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CourseTypeAggregatorSum>;
  avg?: Maybe<CourseTypeAggregatorAvg>;
  min?: Maybe<CourseTypeAggregatorMin>;
  max?: Maybe<CourseTypeAggregatorMax>;
};

export type CourseTypeAggregatorAvg = {
  __typename?: 'CourseTypeAggregatorAvg';
  Price?: Maybe<Scalars['Float']>;
};

export type CourseTypeAggregatorMax = {
  __typename?: 'CourseTypeAggregatorMax';
  Price?: Maybe<Scalars['Float']>;
};

export type CourseTypeAggregatorMin = {
  __typename?: 'CourseTypeAggregatorMin';
  Price?: Maybe<Scalars['Float']>;
};

export type CourseTypeAggregatorSum = {
  __typename?: 'CourseTypeAggregatorSum';
  Price?: Maybe<Scalars['Float']>;
};

export type CourseTypeConnection = {
  __typename?: 'CourseTypeConnection';
  values?: Maybe<Array<Maybe<CourseType>>>;
  groupBy?: Maybe<CourseTypeGroupBy>;
  aggregate?: Maybe<CourseTypeAggregator>;
};

export type CourseTypeConnection_id = {
  __typename?: 'CourseTypeConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionCourseLogo = {
  __typename?: 'CourseTypeConnectionCourseLogo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionCourseLogoMainSlider = {
  __typename?: 'CourseTypeConnectionCourseLogoMainSlider';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionCreatedAt = {
  __typename?: 'CourseTypeConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionDescription = {
  __typename?: 'CourseTypeConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionDuration = {
  __typename?: 'CourseTypeConnectionDuration';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionId = {
  __typename?: 'CourseTypeConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionImage = {
  __typename?: 'CourseTypeConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionIsActive = {
  __typename?: 'CourseTypeConnectionIsActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionName = {
  __typename?: 'CourseTypeConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionNotes = {
  __typename?: 'CourseTypeConnectionNotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionPrice = {
  __typename?: 'CourseTypeConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionShortDescription = {
  __typename?: 'CourseTypeConnectionShortDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionSlug = {
  __typename?: 'CourseTypeConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionUpdatedAt = {
  __typename?: 'CourseTypeConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeConnectionVenue = {
  __typename?: 'CourseTypeConnectionVenue';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CourseTypeConnection>;
};

export type CourseTypeGroupBy = {
  __typename?: 'CourseTypeGroupBy';
  id?: Maybe<Array<Maybe<CourseTypeConnectionId>>>;
  _id?: Maybe<Array<Maybe<CourseTypeConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<CourseTypeConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CourseTypeConnectionUpdatedAt>>>;
  Name?: Maybe<Array<Maybe<CourseTypeConnectionName>>>;
  Price?: Maybe<Array<Maybe<CourseTypeConnectionPrice>>>;
  Description?: Maybe<Array<Maybe<CourseTypeConnectionDescription>>>;
  Venue?: Maybe<Array<Maybe<CourseTypeConnectionVenue>>>;
  Duration?: Maybe<Array<Maybe<CourseTypeConnectionDuration>>>;
  ShortDescription?: Maybe<Array<Maybe<CourseTypeConnectionShortDescription>>>;
  Image?: Maybe<Array<Maybe<CourseTypeConnectionImage>>>;
  Slug?: Maybe<Array<Maybe<CourseTypeConnectionSlug>>>;
  IsActive?: Maybe<Array<Maybe<CourseTypeConnectionIsActive>>>;
  Notes?: Maybe<Array<Maybe<CourseTypeConnectionNotes>>>;
  CourseLogo?: Maybe<Array<Maybe<CourseTypeConnectionCourseLogo>>>;
  CourseLogoMainSlider?: Maybe<Array<Maybe<CourseTypeConnectionCourseLogoMainSlider>>>;
};

export type CourseTypeInput = {
  Name?: Maybe<Scalars['String']>;
  Price?: Maybe<Scalars['Float']>;
  Description?: Maybe<Scalars['String']>;
  Venue?: Maybe<Scalars['String']>;
  Agenda?: Maybe<Array<Maybe<ComponentEventScheduleInput>>>;
  Duration?: Maybe<ENUM_COURSETYPE_DURATION>;
  Courses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ShortDescription?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  Slug?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  Vouchers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CourseLogo?: Maybe<Scalars['ID']>;
  CourseLogoMainSlider?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type createBookingInput = {
  data?: Maybe<BookingInput>;
};

export type createBookingPayload = {
  __typename?: 'createBookingPayload';
  booking?: Maybe<Booking>;
};

export type createCourseInput = {
  data?: Maybe<CourseInput>;
};

export type createCoursePayload = {
  __typename?: 'createCoursePayload';
  course?: Maybe<Course>;
};

export type createCourseTypeInput = {
  data?: Maybe<CourseTypeInput>;
};

export type createCourseTypePayload = {
  __typename?: 'createCourseTypePayload';
  courseType?: Maybe<CourseType>;
};

export type createCustomerInput = {
  data?: Maybe<CustomerInput>;
};

export type createCustomerPayload = {
  __typename?: 'createCustomerPayload';
  customer?: Maybe<Customer>;
};

export type createFooterInput = {
  data?: Maybe<FooterInput>;
};

export type createFooterPayload = {
  __typename?: 'createFooterPayload';
  footer?: Maybe<Footer>;
};

export type createGenericPageInput = {
  data?: Maybe<GenericPageInput>;
};

export type createGenericPagePayload = {
  __typename?: 'createGenericPagePayload';
  genericPage?: Maybe<GenericPage>;
};

export type createNavigationInput = {
  data?: Maybe<NavigationInput>;
};

export type createNavigationPayload = {
  __typename?: 'createNavigationPayload';
  navigation?: Maybe<Navigation>;
};

export type createRoleInput = {
  data?: Maybe<RoleInput>;
};

export type createRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type createTokenInput = {
  data?: Maybe<TokenInput>;
};

export type createTokenPayload = {
  __typename?: 'createTokenPayload';
  token?: Maybe<Token>;
};

export type createUserInput = {
  data?: Maybe<UserInput>;
};

export type createUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type createVehicleInput = {
  data?: Maybe<VehicleInput>;
};

export type createVehiclePayload = {
  __typename?: 'createVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type createVoucherInput = {
  data?: Maybe<VoucherInput>;
};

export type createVoucherPayload = {
  __typename?: 'createVoucherPayload';
  voucher?: Maybe<Voucher>;
};

export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  FirstName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  r_fullName?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  DriversLicense?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['Boolean']>;
  MarketingConsentText?: Maybe<Scalars['String']>;
  Title?: Maybe<ENUM_CUSTOMER_TITLE>;
  Dietary?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  CorporateCustomer?: Maybe<Scalars['Boolean']>;
  Bookings?: Maybe<Array<Maybe<Booking>>>;
  VouchersFor?: Maybe<Array<Maybe<Voucher>>>;
  VouchersBy?: Maybe<Array<Maybe<Voucher>>>;
};


export type CustomerBookingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CustomerVouchersForArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CustomerVouchersByArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CustomerAggregator = {
  __typename?: 'CustomerAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  values?: Maybe<Array<Maybe<Customer>>>;
  groupBy?: Maybe<CustomerGroupBy>;
  aggregate?: Maybe<CustomerAggregator>;
};

export type CustomerConnection_id = {
  __typename?: 'CustomerConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionCorporateCustomer = {
  __typename?: 'CustomerConnectionCorporateCustomer';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionCreatedAt = {
  __typename?: 'CustomerConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionDietary = {
  __typename?: 'CustomerConnectionDietary';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionDriversLicense = {
  __typename?: 'CustomerConnectionDriversLicense';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionEmail = {
  __typename?: 'CustomerConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionFirstName = {
  __typename?: 'CustomerConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionId = {
  __typename?: 'CustomerConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionLastName = {
  __typename?: 'CustomerConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionMarketingConsent = {
  __typename?: 'CustomerConnectionMarketingConsent';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionMarketingConsentText = {
  __typename?: 'CustomerConnectionMarketingConsentText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionNotes = {
  __typename?: 'CustomerConnectionNotes';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionPhone = {
  __typename?: 'CustomerConnectionPhone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionPostalCode = {
  __typename?: 'CustomerConnectionPostalCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionR_fullName = {
  __typename?: 'CustomerConnectionR_fullName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionTitle = {
  __typename?: 'CustomerConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionUpdatedAt = {
  __typename?: 'CustomerConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerGroupBy = {
  __typename?: 'CustomerGroupBy';
  id?: Maybe<Array<Maybe<CustomerConnectionId>>>;
  _id?: Maybe<Array<Maybe<CustomerConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<CustomerConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CustomerConnectionUpdatedAt>>>;
  FirstName?: Maybe<Array<Maybe<CustomerConnectionFirstName>>>;
  LastName?: Maybe<Array<Maybe<CustomerConnectionLastName>>>;
  r_fullName?: Maybe<Array<Maybe<CustomerConnectionR_fullName>>>;
  Phone?: Maybe<Array<Maybe<CustomerConnectionPhone>>>;
  Email?: Maybe<Array<Maybe<CustomerConnectionEmail>>>;
  DriversLicense?: Maybe<Array<Maybe<CustomerConnectionDriversLicense>>>;
  MarketingConsent?: Maybe<Array<Maybe<CustomerConnectionMarketingConsent>>>;
  MarketingConsentText?: Maybe<Array<Maybe<CustomerConnectionMarketingConsentText>>>;
  Title?: Maybe<Array<Maybe<CustomerConnectionTitle>>>;
  Dietary?: Maybe<Array<Maybe<CustomerConnectionDietary>>>;
  PostalCode?: Maybe<Array<Maybe<CustomerConnectionPostalCode>>>;
  Notes?: Maybe<Array<Maybe<CustomerConnectionNotes>>>;
  CorporateCustomer?: Maybe<Array<Maybe<CustomerConnectionCorporateCustomer>>>;
};

export type CustomerInput = {
  FirstName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  r_fullName?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  DriversLicense?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['Boolean']>;
  MarketingConsentText?: Maybe<Scalars['String']>;
  Bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VouchersFor?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VouchersBy?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Title?: Maybe<ENUM_CUSTOMER_TITLE>;
  Dietary?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  CorporateCustomer?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};



export type deleteBookingInput = {
  where?: Maybe<InputID>;
};

export type deleteBookingPayload = {
  __typename?: 'deleteBookingPayload';
  booking?: Maybe<Booking>;
};

export type deleteCourseInput = {
  where?: Maybe<InputID>;
};

export type deleteCoursePayload = {
  __typename?: 'deleteCoursePayload';
  course?: Maybe<Course>;
};

export type deleteCourseTypeInput = {
  where?: Maybe<InputID>;
};

export type deleteCourseTypePayload = {
  __typename?: 'deleteCourseTypePayload';
  courseType?: Maybe<CourseType>;
};

export type deleteCustomerInput = {
  where?: Maybe<InputID>;
};

export type deleteCustomerPayload = {
  __typename?: 'deleteCustomerPayload';
  customer?: Maybe<Customer>;
};

export type deleteFileInput = {
  where?: Maybe<InputID>;
};

export type deleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type deleteFooterInput = {
  where?: Maybe<InputID>;
};

export type deleteFooterPayload = {
  __typename?: 'deleteFooterPayload';
  footer?: Maybe<Footer>;
};

export type deleteGenericPageInput = {
  where?: Maybe<InputID>;
};

export type deleteGenericPagePayload = {
  __typename?: 'deleteGenericPagePayload';
  genericPage?: Maybe<GenericPage>;
};

export type deleteLegalPayload = {
  __typename?: 'deleteLegalPayload';
  legal?: Maybe<Legal>;
};

export type deleteNavigationInput = {
  where?: Maybe<InputID>;
};

export type deleteNavigationPayload = {
  __typename?: 'deleteNavigationPayload';
  navigation?: Maybe<Navigation>;
};

export type deleteRoleInput = {
  where?: Maybe<InputID>;
};

export type deleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type deleteSocialMediaPayload = {
  __typename?: 'deleteSocialMediaPayload';
  socialMedia?: Maybe<SocialMedia>;
};

export type deleteTokenInput = {
  where?: Maybe<InputID>;
};

export type deleteTokenPayload = {
  __typename?: 'deleteTokenPayload';
  token?: Maybe<Token>;
};

export type deleteUserInput = {
  where?: Maybe<InputID>;
};

export type deleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type deleteVehicleInput = {
  where?: Maybe<InputID>;
};

export type deleteVehiclePayload = {
  __typename?: 'deleteVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type deleteVoucherInput = {
  where?: Maybe<InputID>;
};

export type deleteVoucherPayload = {
  __typename?: 'deleteVoucherPayload';
  voucher?: Maybe<Voucher>;
};

export type editBookingInput = {
  Voucher?: Maybe<Scalars['ID']>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  HasAcceptedIndemnity?: Maybe<Scalars['Boolean']>;
  Spectator?: Maybe<editComponentEventSpectatorInput>;
  Course?: Maybe<Scalars['ID']>;
  Customer?: Maybe<Scalars['ID']>;
  r_customerFullName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
  r_courseDate?: Maybe<Scalars['Date']>;
  Notes?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editComponentContentImageOrVideoInput = {
  id?: Maybe<Scalars['ID']>;
  Image?: Maybe<Scalars['ID']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type editComponentContentLinkBlockInput = {
  id?: Maybe<Scalars['ID']>;
  Description?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  Link?: Maybe<editComponentNavigationLinkInput>;
};

export type editComponentContentMarkdownInput = {
  id?: Maybe<Scalars['ID']>;
  Content?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
};

export type editComponentContentSliderInput = {
  id?: Maybe<Scalars['ID']>;
  Image?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<editComponentNavigationLinkInput>;
  CTASecondary?: Maybe<editComponentNavigationLinkInput>;
  EventDate?: Maybe<Scalars['Date']>;
  Position?: Maybe<ENUM_COMPONENTCONTENTSLIDER_POSITION>;
  CourseType?: Maybe<Scalars['ID']>;
};

export type editComponentContentTabInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  Paragraph?: Maybe<Scalars['String']>;
  Layout?: Maybe<ENUM_COMPONENTCONTENTTAB_LAYOUT>;
  YouTubeUrl?: Maybe<Scalars['String']>;
};

export type editComponentContentTableCellInput = {
  id?: Maybe<Scalars['ID']>;
  Text?: Maybe<Scalars['String']>;
};

export type editComponentContentTableInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
};

export type editComponentContentTableRowInput = {
  id?: Maybe<Scalars['ID']>;
  TableCell?: Maybe<Array<Maybe<editComponentContentTableCellInput>>>;
};

export type editComponentContentTitleInput = {
  id?: Maybe<Scalars['ID']>;
  Text?: Maybe<Scalars['String']>;
  Subtext?: Maybe<Scalars['String']>;
  HeadingSize?: Maybe<ENUM_COMPONENTCONTENTTITLE_HEADINGSIZE>;
};

export type editComponentEventScheduleInput = {
  id?: Maybe<Scalars['ID']>;
  Time?: Maybe<Scalars['Time']>;
  Description?: Maybe<Scalars['String']>;
};

export type editComponentEventSpectatorInput = {
  id?: Maybe<Scalars['ID']>;
  Name?: Maybe<Scalars['String']>;
  Dietary?: Maybe<Scalars['String']>;
};

export type editComponentLayoutAvailableCourseListingInput = {
  id?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutBookingFormInput = {
  id?: Maybe<Scalars['ID']>;
  CourseType?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutContactFormInput = {
  id?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutCourseInformationInput = {
  id?: Maybe<Scalars['ID']>;
  CourseType?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutCtaGroupInput = {
  id?: Maybe<Scalars['ID']>;
  CtaButtons?: Maybe<Array<Maybe<editComponentNavigationLinkInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutDiagonalSliderInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Image?: Maybe<Scalars['ID']>;
  Detail?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<editComponentNavigationLinkInput>;
  CTASecondary?: Maybe<editComponentNavigationLinkInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutImageGridInput = {
  id?: Maybe<Scalars['ID']>;
  Images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Size?: Maybe<editComponentLayoutSectionSizeInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutImageGroupInput = {
  id?: Maybe<Scalars['ID']>;
  FirstImageOrVideo?: Maybe<editComponentContentImageOrVideoInput>;
  SecondImageOrVideo?: Maybe<editComponentContentImageOrVideoInput>;
  ThirdImageOrVideo?: Maybe<editComponentContentImageOrVideoInput>;
  FourthImageOrVideo?: Maybe<editComponentContentImageOrVideoInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutLinkBlockGroupInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  SectionSize?: Maybe<editComponentLayoutSectionSizeInput>;
  Links?: Maybe<Array<Maybe<editComponentContentLinkBlockInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutModelOverviewInput = {
  id?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutParagraphInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<editComponentNavigationLinkInput>;
  CTASecondary?: Maybe<editComponentNavigationLinkInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutSectionSizeInput = {
  id?: Maybe<Scalars['ID']>;
  DesktopSpan?: Maybe<Scalars['Int']>;
  TabletSpan?: Maybe<Scalars['Int']>;
  MobileSpan?: Maybe<Scalars['Int']>;
};

export type editComponentLayoutSliderGroupInput = {
  id?: Maybe<Scalars['ID']>;
  Sliders?: Maybe<Array<Maybe<editComponentContentSliderInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutTabInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Tabs?: Maybe<Array<Maybe<editComponentContentTabInput>>>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutTwoColumnImageFirstInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Image?: Maybe<Scalars['ID']>;
  Text?: Maybe<Scalars['String']>;
  CTAPrimary?: Maybe<editComponentNavigationLinkInput>;
  CTASecondary?: Maybe<editComponentNavigationLinkInput>;
  ImageFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNIMAGEFIRST_IMAGEFIRSTIMAGESIZE>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type editComponentLayoutTwoColumnTextFirstInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Text?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  CTAPrimary?: Maybe<editComponentNavigationLinkInput>;
  CTASecondary?: Maybe<editComponentNavigationLinkInput>;
  TextFirstImageSize?: Maybe<ENUM_COMPONENTLAYOUTTWOCOLUMNTEXTFIRST_TEXTFIRSTIMAGESIZE>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
  YouTubeUrl?: Maybe<Scalars['String']>;
  InstructorProfile?: Maybe<Scalars['String']>;
  course_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type editComponentLayoutTwoColumnTextOnlyInput = {
  id?: Maybe<Scalars['ID']>;
  Title?: Maybe<editComponentContentTitleInput>;
  Text1?: Maybe<Scalars['String']>;
  Text2?: Maybe<Scalars['String']>;
  HasSpacing?: Maybe<Scalars['Boolean']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutVehicleOverviewInput = {
  id?: Maybe<Scalars['ID']>;
  Vehicle?: Maybe<Scalars['ID']>;
  Overview?: Maybe<Scalars['String']>;
  Title?: Maybe<editComponentContentTitleInput>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutVehicleSpecificationsCounterInput = {
  id?: Maybe<Scalars['ID']>;
  vehicle?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentLayoutVoucherFormInput = {
  id?: Maybe<Scalars['ID']>;
  AnchorId?: Maybe<Scalars['String']>;
};

export type editComponentNavigationLinkInput = {
  id?: Maybe<Scalars['ID']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  TextDesktop?: Maybe<Scalars['String']>;
  TextMobile?: Maybe<Scalars['String']>;
  Link?: Maybe<Scalars['String']>;
  ClickClassDesktop?: Maybe<Scalars['String']>;
  ClickClassMobile?: Maybe<Scalars['String']>;
};

export type editCourseInput = {
  Date?: Maybe<Scalars['Date']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  RegistrationOpen?: Maybe<Scalars['Date']>;
  RegistrationClose?: Maybe<Scalars['Date']>;
  CourseType?: Maybe<Scalars['ID']>;
  Bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  r_totalBookings?: Maybe<Scalars['Int']>;
  TotalSpaces?: Maybe<Scalars['Int']>;
  r_availableSpaces?: Maybe<Scalars['Int']>;
  CorporateEvent?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  r_courseType?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editCourseTypeInput = {
  Name?: Maybe<Scalars['String']>;
  Price?: Maybe<Scalars['Float']>;
  Description?: Maybe<Scalars['String']>;
  Venue?: Maybe<Scalars['String']>;
  Agenda?: Maybe<Array<Maybe<editComponentEventScheduleInput>>>;
  Duration?: Maybe<ENUM_COURSETYPE_DURATION>;
  Courses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ShortDescription?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  Slug?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Notes?: Maybe<Scalars['String']>;
  Vouchers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  CourseLogo?: Maybe<Scalars['ID']>;
  CourseLogoMainSlider?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editCustomerInput = {
  FirstName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  r_fullName?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  DriversLicense?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['Boolean']>;
  MarketingConsentText?: Maybe<Scalars['String']>;
  Bookings?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VouchersFor?: Maybe<Array<Maybe<Scalars['ID']>>>;
  VouchersBy?: Maybe<Array<Maybe<Scalars['ID']>>>;
  Title?: Maybe<ENUM_CUSTOMER_TITLE>;
  Dietary?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Notes?: Maybe<Scalars['String']>;
  CorporateCustomer?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editFooterInput = {
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<editComponentNavigationLinkInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editGenericPageInput = {
  Title?: Maybe<Scalars['String']>;
  Slug?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Keywords?: Maybe<Scalars['String']>;
  Sections?: Maybe<Array<Scalars['GenericPageSectionsDynamicZoneInput']>>;
  IsActive?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editLegalInput = {
  CookiesUrl?: Maybe<Scalars['String']>;
  DataProtectionUrl?: Maybe<Scalars['String']>;
  LegalNoticeUrl?: Maybe<Scalars['String']>;
  ProviderUrl?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editNavigationInput = {
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<editComponentNavigationLinkInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editSocialMediaInput = {
  Facebook?: Maybe<Scalars['String']>;
  LinkedIn?: Maybe<Scalars['String']>;
  Youtube?: Maybe<Scalars['String']>;
  Twitter?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  Pinterest?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editTokenInput = {
  token?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  token?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editVehicleInput = {
  Name?: Maybe<Scalars['String']>;
  Engine?: Maybe<Scalars['String']>;
  Body?: Maybe<ENUM_VEHICLE_BODY>;
  Price?: Maybe<Scalars['Float']>;
  EngineDescription?: Maybe<Scalars['String']>;
  Gearbox?: Maybe<Scalars['String']>;
  TopSpeed?: Maybe<Scalars['String']>;
  Power?: Maybe<Scalars['String']>;
  Torque?: Maybe<Scalars['String']>;
  Acceleration?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  TypeClass?: Maybe<Scalars['String']>;
  PageSlug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type editVoucherInput = {
  Code?: Maybe<Scalars['String']>;
  Expiry?: Maybe<Scalars['Date']>;
  Booking?: Maybe<Scalars['ID']>;
  CustomerFor?: Maybe<Scalars['ID']>;
  CustomerBy?: Maybe<Scalars['ID']>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  CourseType?: Maybe<Scalars['ID']>;
  r_customerForName?: Maybe<Scalars['String']>;
  r_customerByName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum ENUM_COMPONENTCONTENTSLIDER_POSITION {
  Left = 'Left',
  Right = 'Right'
}

export enum ENUM_COMPONENTCONTENTTAB_LAYOUT {
  TextFirst = 'TextFirst',
  ImageFirst = 'ImageFirst'
}

export enum ENUM_COMPONENTCONTENTTITLE_HEADINGSIZE {
  HeadingXXL = 'HeadingXXL',
  HeadingXL = 'HeadingXL',
  HeadingL = 'HeadingL',
  HeadingM = 'HeadingM',
  HeadingS = 'HeadingS',
  HeadingXS = 'HeadingXS'
}

export enum ENUM_COMPONENTLAYOUTTWOCOLUMNIMAGEFIRST_IMAGEFIRSTIMAGESIZE {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}

export enum ENUM_COMPONENTLAYOUTTWOCOLUMNTEXTFIRST_TEXTFIRSTIMAGESIZE {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large'
}

export enum ENUM_COURSETYPE_DURATION {
  FullDay = 'FullDay',
  HalfDay = 'HalfDay'
}

export enum ENUM_CUSTOMER_TITLE {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Dr = 'Dr',
  Prof = 'Prof'
}

export enum ENUM_VEHICLE_BODY {
  Sedan = 'Sedan',
  OffRoader = 'OffRoader',
  Coupe = 'Coupe',
  Cabriolet = 'Cabriolet',
  Hatchback = 'Hatchback',
  Roadster = 'Roadster',
  SportsTourer = 'SportsTourer'
}

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Footer = {
  __typename?: 'Footer';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<ComponentNavigationLink>>>;
};

export type FooterAggregator = {
  __typename?: 'FooterAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FooterConnection = {
  __typename?: 'FooterConnection';
  values?: Maybe<Array<Maybe<Footer>>>;
  groupBy?: Maybe<FooterGroupBy>;
  aggregate?: Maybe<FooterAggregator>;
};

export type FooterConnection_id = {
  __typename?: 'FooterConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionCreatedAt = {
  __typename?: 'FooterConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionId = {
  __typename?: 'FooterConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionIsActive = {
  __typename?: 'FooterConnectionIsActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionName = {
  __typename?: 'FooterConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterConnectionUpdatedAt = {
  __typename?: 'FooterConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FooterConnection>;
};

export type FooterGroupBy = {
  __typename?: 'FooterGroupBy';
  id?: Maybe<Array<Maybe<FooterConnectionId>>>;
  _id?: Maybe<Array<Maybe<FooterConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<FooterConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<FooterConnectionUpdatedAt>>>;
  Name?: Maybe<Array<Maybe<FooterConnectionName>>>;
  IsActive?: Maybe<Array<Maybe<FooterConnectionIsActive>>>;
};

export type FooterInput = {
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<ComponentNavigationLinkInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type GenericPage = {
  __typename?: 'GenericPage';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Title?: Maybe<Scalars['String']>;
  Slug: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  Keywords?: Maybe<Scalars['String']>;
  Sections?: Maybe<Array<Maybe<GenericPageSectionsDynamicZone>>>;
  IsActive?: Maybe<Scalars['Boolean']>;
};

export type GenericPageAggregator = {
  __typename?: 'GenericPageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GenericPageConnection = {
  __typename?: 'GenericPageConnection';
  values?: Maybe<Array<Maybe<GenericPage>>>;
  groupBy?: Maybe<GenericPageGroupBy>;
  aggregate?: Maybe<GenericPageAggregator>;
};

export type GenericPageConnection_id = {
  __typename?: 'GenericPageConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionCreatedAt = {
  __typename?: 'GenericPageConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionDescription = {
  __typename?: 'GenericPageConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionId = {
  __typename?: 'GenericPageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionIsActive = {
  __typename?: 'GenericPageConnectionIsActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionKeywords = {
  __typename?: 'GenericPageConnectionKeywords';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionSlug = {
  __typename?: 'GenericPageConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionTitle = {
  __typename?: 'GenericPageConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageConnectionUpdatedAt = {
  __typename?: 'GenericPageConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<GenericPageConnection>;
};

export type GenericPageGroupBy = {
  __typename?: 'GenericPageGroupBy';
  id?: Maybe<Array<Maybe<GenericPageConnectionId>>>;
  _id?: Maybe<Array<Maybe<GenericPageConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<GenericPageConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<GenericPageConnectionUpdatedAt>>>;
  Title?: Maybe<Array<Maybe<GenericPageConnectionTitle>>>;
  Slug?: Maybe<Array<Maybe<GenericPageConnectionSlug>>>;
  Description?: Maybe<Array<Maybe<GenericPageConnectionDescription>>>;
  Keywords?: Maybe<Array<Maybe<GenericPageConnectionKeywords>>>;
  IsActive?: Maybe<Array<Maybe<GenericPageConnectionIsActive>>>;
};

export type GenericPageInput = {
  Title?: Maybe<Scalars['String']>;
  Slug: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  Keywords?: Maybe<Scalars['String']>;
  Sections?: Maybe<Array<Scalars['GenericPageSectionsDynamicZoneInput']>>;
  IsActive?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type GenericPageSectionsDynamicZone = ComponentLayoutCourseInformation | ComponentLayoutVehicleOverview | ComponentLayoutSliderGroup | ComponentLayoutLinkBlockGroup | ComponentLayoutAvailableCourseListing | ComponentLayoutDiagonalSlider | ComponentLayoutParagraph | ComponentLayoutTwoColumnImageFirst | ComponentLayoutTwoColumnTextFirst | ComponentLayoutTwoColumnTextOnly | ComponentLayoutImageGroup | ComponentLayoutTabs | ComponentLayoutImageGrid | ComponentLayoutCtaGroup | ComponentLayoutModelOverview | ComponentLayoutContactForm | ComponentLayoutBookingForm | ComponentLayoutVoucherForm | ComponentLayoutVehicleSpecificationsCounter;


export type InputID = {
  id: Scalars['ID'];
};


export type Legal = {
  __typename?: 'Legal';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  CookiesUrl?: Maybe<Scalars['String']>;
  DataProtectionUrl?: Maybe<Scalars['String']>;
  LegalNoticeUrl?: Maybe<Scalars['String']>;
  ProviderUrl?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['String']>;
};

export type LegalInput = {
  CookiesUrl?: Maybe<Scalars['String']>;
  DataProtectionUrl?: Maybe<Scalars['String']>;
  LegalNoticeUrl?: Maybe<Scalars['String']>;
  ProviderUrl?: Maybe<Scalars['String']>;
  MarketingConsent?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | Booking | BookingConnection | BookingAggregator | BookingGroupBy | BookingConnectionId | BookingConnection_id | BookingConnectionCreatedAt | BookingConnectionUpdatedAt | BookingConnectionVoucher | BookingConnectionHasPaid | BookingConnectionHasAcceptedIndemnity | BookingConnectionSpectator | BookingConnectionCourse | BookingConnectionCustomer | BookingConnectionR_customerFullName | BookingConnectionR_courseTypeName | BookingConnectionR_courseDate | BookingConnectionNotes | createBookingPayload | updateBookingPayload | deleteBookingPayload | CourseType | CourseTypeConnection | CourseTypeAggregator | CourseTypeAggregatorSum | CourseTypeAggregatorAvg | CourseTypeAggregatorMin | CourseTypeAggregatorMax | CourseTypeGroupBy | CourseTypeConnectionId | CourseTypeConnection_id | CourseTypeConnectionCreatedAt | CourseTypeConnectionUpdatedAt | CourseTypeConnectionName | CourseTypeConnectionPrice | CourseTypeConnectionDescription | CourseTypeConnectionVenue | CourseTypeConnectionDuration | CourseTypeConnectionShortDescription | CourseTypeConnectionImage | CourseTypeConnectionSlug | CourseTypeConnectionIsActive | CourseTypeConnectionNotes | CourseTypeConnectionCourseLogo | CourseTypeConnectionCourseLogoMainSlider | createCourseTypePayload | updateCourseTypePayload | deleteCourseTypePayload | Course | CourseConnection | CourseAggregator | CourseAggregatorSum | CourseAggregatorAvg | CourseAggregatorMin | CourseAggregatorMax | CourseGroupBy | CourseConnectionId | CourseConnection_id | CourseConnectionCreatedAt | CourseConnectionUpdatedAt | CourseConnectionDate | CourseConnectionIsActive | CourseConnectionRegistrationOpen | CourseConnectionRegistrationClose | CourseConnectionCourseType | CourseConnectionR_totalBookings | CourseConnectionTotalSpaces | CourseConnectionR_availableSpaces | CourseConnectionCorporateEvent | CourseConnectionNotes | CourseConnectionR_courseType | createCoursePayload | updateCoursePayload | deleteCoursePayload | Customer | CustomerConnection | CustomerAggregator | CustomerGroupBy | CustomerConnectionId | CustomerConnection_id | CustomerConnectionCreatedAt | CustomerConnectionUpdatedAt | CustomerConnectionFirstName | CustomerConnectionLastName | CustomerConnectionR_fullName | CustomerConnectionPhone | CustomerConnectionEmail | CustomerConnectionDriversLicense | CustomerConnectionMarketingConsent | CustomerConnectionMarketingConsentText | CustomerConnectionTitle | CustomerConnectionDietary | CustomerConnectionPostalCode | CustomerConnectionNotes | CustomerConnectionCorporateCustomer | createCustomerPayload | updateCustomerPayload | deleteCustomerPayload | Footer | FooterConnection | FooterAggregator | FooterGroupBy | FooterConnectionId | FooterConnection_id | FooterConnectionCreatedAt | FooterConnectionUpdatedAt | FooterConnectionName | FooterConnectionIsActive | createFooterPayload | updateFooterPayload | deleteFooterPayload | GenericPage | GenericPageConnection | GenericPageAggregator | GenericPageGroupBy | GenericPageConnectionId | GenericPageConnection_id | GenericPageConnectionCreatedAt | GenericPageConnectionUpdatedAt | GenericPageConnectionTitle | GenericPageConnectionSlug | GenericPageConnectionDescription | GenericPageConnectionKeywords | GenericPageConnectionIsActive | createGenericPagePayload | updateGenericPagePayload | deleteGenericPagePayload | Legal | updateLegalPayload | deleteLegalPayload | Navigation | NavigationConnection | NavigationAggregator | NavigationGroupBy | NavigationConnectionId | NavigationConnection_id | NavigationConnectionCreatedAt | NavigationConnectionUpdatedAt | NavigationConnectionName | NavigationConnectionIsActive | createNavigationPayload | updateNavigationPayload | deleteNavigationPayload | SocialMedia | updateSocialMediaPayload | deleteSocialMediaPayload | Token | TokenConnection | TokenAggregator | TokenGroupBy | TokenConnectionId | TokenConnection_id | TokenConnectionCreatedAt | TokenConnectionUpdatedAt | TokenConnectionToken | TokenConnectionUser | createTokenPayload | updateTokenPayload | deleteTokenPayload | Vehicle | VehicleConnection | VehicleAggregator | VehicleAggregatorSum | VehicleAggregatorAvg | VehicleAggregatorMin | VehicleAggregatorMax | VehicleGroupBy | VehicleConnectionId | VehicleConnection_id | VehicleConnectionCreatedAt | VehicleConnectionUpdatedAt | VehicleConnectionName | VehicleConnectionEngine | VehicleConnectionBody | VehicleConnectionPrice | VehicleConnectionEngineDescription | VehicleConnectionGearbox | VehicleConnectionTopSpeed | VehicleConnectionPower | VehicleConnectionTorque | VehicleConnectionAcceleration | VehicleConnectionImage | VehicleConnectionTypeClass | VehicleConnectionPageSlug | createVehiclePayload | updateVehiclePayload | deleteVehiclePayload | Voucher | VoucherConnection | VoucherAggregator | VoucherGroupBy | VoucherConnectionId | VoucherConnection_id | VoucherConnectionCreatedAt | VoucherConnectionUpdatedAt | VoucherConnectionCode | VoucherConnectionExpiry | VoucherConnectionBooking | VoucherConnectionCustomerFor | VoucherConnectionCustomerBy | VoucherConnectionHasPaid | VoucherConnectionCourseType | VoucherConnectionR_customerForName | VoucherConnectionR_customerByName | VoucherConnectionR_courseTypeName | createVoucherPayload | updateVoucherPayload | deleteVoucherPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnection_id | UploadFileConnectionCreatedAt | UploadFileConnectionUpdatedAt | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_metadata | deleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnection_id | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | createRolePayload | updateRolePayload | deleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnection_id | UsersPermissionsUserConnectionCreatedAt | UsersPermissionsUserConnectionUpdatedAt | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionToken | createUserPayload | updateUserPayload | deleteUserPayload | ComponentContentImageOrVideo | ComponentContentLinkBlock | ComponentContentMarkdown | ComponentContentSlider | ComponentContentTab | ComponentContentTableCell | ComponentContentTableRow | ComponentContentTable | ComponentContentTitle | ComponentEventSchedule | ComponentEventSpectator | ComponentLayoutAvailableCourseListing | ComponentLayoutBookingForm | ComponentLayoutContactForm | ComponentLayoutCourseInformation | ComponentLayoutCtaGroup | ComponentLayoutDiagonalSlider | ComponentLayoutImageGrid | ComponentLayoutImageGroup | ComponentLayoutLinkBlockGroup | ComponentLayoutModelOverview | ComponentLayoutParagraph | ComponentLayoutSectionSize | ComponentLayoutSliderGroup | ComponentLayoutTabs | ComponentLayoutTwoColumnImageFirst | ComponentLayoutTwoColumnTextFirst | ComponentLayoutTwoColumnTextOnly | ComponentLayoutVehicleOverview | ComponentLayoutVehicleSpecificationsCounter | ComponentLayoutVoucherForm | ComponentNavigationLink;

export type Mutation = {
  __typename?: 'Mutation';
  createBooking?: Maybe<createBookingPayload>;
  updateBooking?: Maybe<updateBookingPayload>;
  deleteBooking?: Maybe<deleteBookingPayload>;
  createCourseType?: Maybe<createCourseTypePayload>;
  updateCourseType?: Maybe<updateCourseTypePayload>;
  deleteCourseType?: Maybe<deleteCourseTypePayload>;
  createCourse?: Maybe<createCoursePayload>;
  updateCourse?: Maybe<updateCoursePayload>;
  deleteCourse?: Maybe<deleteCoursePayload>;
  createCustomer?: Maybe<createCustomerPayload>;
  updateCustomer?: Maybe<updateCustomerPayload>;
  deleteCustomer?: Maybe<deleteCustomerPayload>;
  createFooter?: Maybe<createFooterPayload>;
  updateFooter?: Maybe<updateFooterPayload>;
  deleteFooter?: Maybe<deleteFooterPayload>;
  createGenericPage?: Maybe<createGenericPagePayload>;
  updateGenericPage?: Maybe<updateGenericPagePayload>;
  deleteGenericPage?: Maybe<deleteGenericPagePayload>;
  updateLegal?: Maybe<updateLegalPayload>;
  deleteLegal?: Maybe<deleteLegalPayload>;
  createNavigation?: Maybe<createNavigationPayload>;
  updateNavigation?: Maybe<updateNavigationPayload>;
  deleteNavigation?: Maybe<deleteNavigationPayload>;
  updateSocialMedia?: Maybe<updateSocialMediaPayload>;
  deleteSocialMedia?: Maybe<deleteSocialMediaPayload>;
  createToken?: Maybe<createTokenPayload>;
  updateToken?: Maybe<updateTokenPayload>;
  deleteToken?: Maybe<deleteTokenPayload>;
  createVehicle?: Maybe<createVehiclePayload>;
  updateVehicle?: Maybe<updateVehiclePayload>;
  deleteVehicle?: Maybe<deleteVehiclePayload>;
  createVoucher?: Maybe<createVoucherPayload>;
  updateVoucher?: Maybe<updateVoucherPayload>;
  deleteVoucher?: Maybe<deleteVoucherPayload>;
  /** Delete one file */
  deleteFile?: Maybe<deleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<createRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<updateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<deleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<createUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<updateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<deleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationcreateBookingArgs = {
  input?: Maybe<createBookingInput>;
};


export type MutationupdateBookingArgs = {
  input?: Maybe<updateBookingInput>;
};


export type MutationdeleteBookingArgs = {
  input?: Maybe<deleteBookingInput>;
};


export type MutationcreateCourseTypeArgs = {
  input?: Maybe<createCourseTypeInput>;
};


export type MutationupdateCourseTypeArgs = {
  input?: Maybe<updateCourseTypeInput>;
};


export type MutationdeleteCourseTypeArgs = {
  input?: Maybe<deleteCourseTypeInput>;
};


export type MutationcreateCourseArgs = {
  input?: Maybe<createCourseInput>;
};


export type MutationupdateCourseArgs = {
  input?: Maybe<updateCourseInput>;
};


export type MutationdeleteCourseArgs = {
  input?: Maybe<deleteCourseInput>;
};


export type MutationcreateCustomerArgs = {
  input?: Maybe<createCustomerInput>;
};


export type MutationupdateCustomerArgs = {
  input?: Maybe<updateCustomerInput>;
};


export type MutationdeleteCustomerArgs = {
  input?: Maybe<deleteCustomerInput>;
};


export type MutationcreateFooterArgs = {
  input?: Maybe<createFooterInput>;
};


export type MutationupdateFooterArgs = {
  input?: Maybe<updateFooterInput>;
};


export type MutationdeleteFooterArgs = {
  input?: Maybe<deleteFooterInput>;
};


export type MutationcreateGenericPageArgs = {
  input?: Maybe<createGenericPageInput>;
};


export type MutationupdateGenericPageArgs = {
  input?: Maybe<updateGenericPageInput>;
};


export type MutationdeleteGenericPageArgs = {
  input?: Maybe<deleteGenericPageInput>;
};


export type MutationupdateLegalArgs = {
  input?: Maybe<updateLegalInput>;
};


export type MutationcreateNavigationArgs = {
  input?: Maybe<createNavigationInput>;
};


export type MutationupdateNavigationArgs = {
  input?: Maybe<updateNavigationInput>;
};


export type MutationdeleteNavigationArgs = {
  input?: Maybe<deleteNavigationInput>;
};


export type MutationupdateSocialMediaArgs = {
  input?: Maybe<updateSocialMediaInput>;
};


export type MutationcreateTokenArgs = {
  input?: Maybe<createTokenInput>;
};


export type MutationupdateTokenArgs = {
  input?: Maybe<updateTokenInput>;
};


export type MutationdeleteTokenArgs = {
  input?: Maybe<deleteTokenInput>;
};


export type MutationcreateVehicleArgs = {
  input?: Maybe<createVehicleInput>;
};


export type MutationupdateVehicleArgs = {
  input?: Maybe<updateVehicleInput>;
};


export type MutationdeleteVehicleArgs = {
  input?: Maybe<deleteVehicleInput>;
};


export type MutationcreateVoucherArgs = {
  input?: Maybe<createVoucherInput>;
};


export type MutationupdateVoucherArgs = {
  input?: Maybe<updateVoucherInput>;
};


export type MutationdeleteVoucherArgs = {
  input?: Maybe<deleteVoucherInput>;
};


export type MutationdeleteFileArgs = {
  input?: Maybe<deleteFileInput>;
};


export type MutationcreateRoleArgs = {
  input?: Maybe<createRoleInput>;
};


export type MutationupdateRoleArgs = {
  input?: Maybe<updateRoleInput>;
};


export type MutationdeleteRoleArgs = {
  input?: Maybe<deleteRoleInput>;
};


export type MutationcreateUserArgs = {
  input?: Maybe<createUserInput>;
};


export type MutationupdateUserArgs = {
  input?: Maybe<updateUserInput>;
};


export type MutationdeleteUserArgs = {
  input?: Maybe<deleteUserInput>;
};


export type MutationuploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationmultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationupdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationloginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationregisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationforgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationresetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationemailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type Navigation = {
  __typename?: 'Navigation';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<ComponentNavigationLink>>>;
};

export type NavigationAggregator = {
  __typename?: 'NavigationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NavigationConnection = {
  __typename?: 'NavigationConnection';
  values?: Maybe<Array<Maybe<Navigation>>>;
  groupBy?: Maybe<NavigationGroupBy>;
  aggregate?: Maybe<NavigationAggregator>;
};

export type NavigationConnection_id = {
  __typename?: 'NavigationConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationConnectionCreatedAt = {
  __typename?: 'NavigationConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationConnectionId = {
  __typename?: 'NavigationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationConnectionIsActive = {
  __typename?: 'NavigationConnectionIsActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationConnectionName = {
  __typename?: 'NavigationConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationConnectionUpdatedAt = {
  __typename?: 'NavigationConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NavigationConnection>;
};

export type NavigationGroupBy = {
  __typename?: 'NavigationGroupBy';
  id?: Maybe<Array<Maybe<NavigationConnectionId>>>;
  _id?: Maybe<Array<Maybe<NavigationConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<NavigationConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<NavigationConnectionUpdatedAt>>>;
  Name?: Maybe<Array<Maybe<NavigationConnectionName>>>;
  IsActive?: Maybe<Array<Maybe<NavigationConnectionIsActive>>>;
};

export type NavigationInput = {
  Name?: Maybe<Scalars['String']>;
  IsActive?: Maybe<Scalars['Boolean']>;
  Links?: Maybe<Array<Maybe<ComponentNavigationLinkInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum PublicationState {
  LIVE = 'LIVE',
  PREVIEW = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  booking?: Maybe<Booking>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  bookingsConnection?: Maybe<BookingConnection>;
  courseType?: Maybe<CourseType>;
  courseTypes?: Maybe<Array<Maybe<CourseType>>>;
  courseTypesConnection?: Maybe<CourseTypeConnection>;
  course?: Maybe<Course>;
  courses?: Maybe<Array<Maybe<Course>>>;
  coursesConnection?: Maybe<CourseConnection>;
  customer?: Maybe<Customer>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  customersConnection?: Maybe<CustomerConnection>;
  footer?: Maybe<Footer>;
  footers?: Maybe<Array<Maybe<Footer>>>;
  footersConnection?: Maybe<FooterConnection>;
  genericPage?: Maybe<GenericPage>;
  genericPages?: Maybe<Array<Maybe<GenericPage>>>;
  genericPagesConnection?: Maybe<GenericPageConnection>;
  legal?: Maybe<Legal>;
  navigation?: Maybe<Navigation>;
  navigations?: Maybe<Array<Maybe<Navigation>>>;
  navigationsConnection?: Maybe<NavigationConnection>;
  socialMedia?: Maybe<SocialMedia>;
  token?: Maybe<Token>;
  tokens?: Maybe<Array<Maybe<Token>>>;
  tokensConnection?: Maybe<TokenConnection>;
  vehicle?: Maybe<Vehicle>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  vehiclesConnection?: Maybe<VehicleConnection>;
  voucher?: Maybe<Voucher>;
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
  vouchersConnection?: Maybe<VoucherConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QuerybookingArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerybookingsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerybookingsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerycourseTypeArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerycourseTypesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerycourseTypesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerycourseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerycoursesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerycoursesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerycustomerArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerycustomersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerycustomersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryfooterArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryfootersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryfootersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerygenericPageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerygenericPagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerygenericPagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerylegalArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QuerynavigationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerynavigationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerynavigationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerysocialMediaArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QuerytokenArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerytokensArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QuerytokensConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryvehicleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryvehiclesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryvehiclesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryvoucherArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryvouchersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryvouchersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryfilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryfilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryroleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryrolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryrolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryuserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryusersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryusersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Facebook?: Maybe<Scalars['String']>;
  LinkedIn?: Maybe<Scalars['String']>;
  Youtube?: Maybe<Scalars['String']>;
  Twitter?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  Pinterest?: Maybe<Scalars['String']>;
};

export type SocialMediaInput = {
  Facebook?: Maybe<Scalars['String']>;
  LinkedIn?: Maybe<Scalars['String']>;
  Youtube?: Maybe<Scalars['String']>;
  Twitter?: Maybe<Scalars['String']>;
  Instagram?: Maybe<Scalars['String']>;
  Pinterest?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type Token = {
  __typename?: 'Token';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type TokenAggregator = {
  __typename?: 'TokenAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TokenConnection = {
  __typename?: 'TokenConnection';
  values?: Maybe<Array<Maybe<Token>>>;
  groupBy?: Maybe<TokenGroupBy>;
  aggregate?: Maybe<TokenAggregator>;
};

export type TokenConnection_id = {
  __typename?: 'TokenConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenConnectionCreatedAt = {
  __typename?: 'TokenConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenConnectionId = {
  __typename?: 'TokenConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenConnectionToken = {
  __typename?: 'TokenConnectionToken';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenConnectionUpdatedAt = {
  __typename?: 'TokenConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenConnectionUser = {
  __typename?: 'TokenConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TokenConnection>;
};

export type TokenGroupBy = {
  __typename?: 'TokenGroupBy';
  id?: Maybe<Array<Maybe<TokenConnectionId>>>;
  _id?: Maybe<Array<Maybe<TokenConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<TokenConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<TokenConnectionUpdatedAt>>>;
  token?: Maybe<Array<Maybe<TokenConnectionToken>>>;
  user?: Maybe<Array<Maybe<TokenConnectionUser>>>;
};

export type TokenInput = {
  token?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type updateBookingInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editBookingInput>;
};

export type updateBookingPayload = {
  __typename?: 'updateBookingPayload';
  booking?: Maybe<Booking>;
};

export type updateCourseInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editCourseInput>;
};

export type updateCoursePayload = {
  __typename?: 'updateCoursePayload';
  course?: Maybe<Course>;
};

export type updateCourseTypeInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editCourseTypeInput>;
};

export type updateCourseTypePayload = {
  __typename?: 'updateCourseTypePayload';
  courseType?: Maybe<CourseType>;
};

export type updateCustomerInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editCustomerInput>;
};

export type updateCustomerPayload = {
  __typename?: 'updateCustomerPayload';
  customer?: Maybe<Customer>;
};

export type updateFooterInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editFooterInput>;
};

export type updateFooterPayload = {
  __typename?: 'updateFooterPayload';
  footer?: Maybe<Footer>;
};

export type updateGenericPageInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editGenericPageInput>;
};

export type updateGenericPagePayload = {
  __typename?: 'updateGenericPagePayload';
  genericPage?: Maybe<GenericPage>;
};

export type updateLegalInput = {
  data?: Maybe<editLegalInput>;
};

export type updateLegalPayload = {
  __typename?: 'updateLegalPayload';
  legal?: Maybe<Legal>;
};

export type updateNavigationInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editNavigationInput>;
};

export type updateNavigationPayload = {
  __typename?: 'updateNavigationPayload';
  navigation?: Maybe<Navigation>;
};

export type updateRoleInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editRoleInput>;
};

export type updateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type updateSocialMediaInput = {
  data?: Maybe<editSocialMediaInput>;
};

export type updateSocialMediaPayload = {
  __typename?: 'updateSocialMediaPayload';
  socialMedia?: Maybe<SocialMedia>;
};

export type updateTokenInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editTokenInput>;
};

export type updateTokenPayload = {
  __typename?: 'updateTokenPayload';
  token?: Maybe<Token>;
};

export type updateUserInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editUserInput>;
};

export type updateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type updateVehicleInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editVehicleInput>;
};

export type updateVehiclePayload = {
  __typename?: 'updateVehiclePayload';
  vehicle?: Maybe<Vehicle>;
};

export type updateVoucherInput = {
  where?: Maybe<InputID>;
  data?: Maybe<editVoucherInput>;
};

export type updateVoucherPayload = {
  __typename?: 'updateVoucherPayload';
  voucher?: Maybe<Voucher>;
};


export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFilerelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnection_id = {
  __typename?: 'UploadFileConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreatedAt = {
  __typename?: 'UploadFileConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdatedAt = {
  __typename?: 'UploadFileConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  _id?: Maybe<Array<Maybe<UploadFileConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<UploadFileConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UploadFileConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  token?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolepermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleusersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnection_id = {
  __typename?: 'UsersPermissionsRoleConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsRoleConnection_id>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  token?: Maybe<Token>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnection_id = {
  __typename?: 'UsersPermissionsUserConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreatedAt = {
  __typename?: 'UsersPermissionsUserConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionToken = {
  __typename?: 'UsersPermissionsUserConnectionToken';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsUserConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsUserConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdatedAt>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  token?: Maybe<Array<Maybe<UsersPermissionsUserConnectionToken>>>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Name?: Maybe<Scalars['String']>;
  Engine?: Maybe<Scalars['String']>;
  Body?: Maybe<ENUM_VEHICLE_BODY>;
  Price?: Maybe<Scalars['Float']>;
  EngineDescription?: Maybe<Scalars['String']>;
  Gearbox?: Maybe<Scalars['String']>;
  TopSpeed?: Maybe<Scalars['String']>;
  Power?: Maybe<Scalars['String']>;
  Torque?: Maybe<Scalars['String']>;
  Acceleration?: Maybe<Scalars['String']>;
  Image?: Maybe<UploadFile>;
  TypeClass?: Maybe<Scalars['String']>;
  PageSlug?: Maybe<Scalars['String']>;
};

export type VehicleAggregator = {
  __typename?: 'VehicleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<VehicleAggregatorSum>;
  avg?: Maybe<VehicleAggregatorAvg>;
  min?: Maybe<VehicleAggregatorMin>;
  max?: Maybe<VehicleAggregatorMax>;
};

export type VehicleAggregatorAvg = {
  __typename?: 'VehicleAggregatorAvg';
  Price?: Maybe<Scalars['Float']>;
};

export type VehicleAggregatorMax = {
  __typename?: 'VehicleAggregatorMax';
  Price?: Maybe<Scalars['Float']>;
};

export type VehicleAggregatorMin = {
  __typename?: 'VehicleAggregatorMin';
  Price?: Maybe<Scalars['Float']>;
};

export type VehicleAggregatorSum = {
  __typename?: 'VehicleAggregatorSum';
  Price?: Maybe<Scalars['Float']>;
};

export type VehicleConnection = {
  __typename?: 'VehicleConnection';
  values?: Maybe<Array<Maybe<Vehicle>>>;
  groupBy?: Maybe<VehicleGroupBy>;
  aggregate?: Maybe<VehicleAggregator>;
};

export type VehicleConnection_id = {
  __typename?: 'VehicleConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionAcceleration = {
  __typename?: 'VehicleConnectionAcceleration';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionBody = {
  __typename?: 'VehicleConnectionBody';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionCreatedAt = {
  __typename?: 'VehicleConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionEngine = {
  __typename?: 'VehicleConnectionEngine';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionEngineDescription = {
  __typename?: 'VehicleConnectionEngineDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionGearbox = {
  __typename?: 'VehicleConnectionGearbox';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionId = {
  __typename?: 'VehicleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionImage = {
  __typename?: 'VehicleConnectionImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionName = {
  __typename?: 'VehicleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionPageSlug = {
  __typename?: 'VehicleConnectionPageSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionPower = {
  __typename?: 'VehicleConnectionPower';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionPrice = {
  __typename?: 'VehicleConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionTopSpeed = {
  __typename?: 'VehicleConnectionTopSpeed';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionTorque = {
  __typename?: 'VehicleConnectionTorque';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionTypeClass = {
  __typename?: 'VehicleConnectionTypeClass';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleConnectionUpdatedAt = {
  __typename?: 'VehicleConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VehicleConnection>;
};

export type VehicleGroupBy = {
  __typename?: 'VehicleGroupBy';
  id?: Maybe<Array<Maybe<VehicleConnectionId>>>;
  _id?: Maybe<Array<Maybe<VehicleConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<VehicleConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<VehicleConnectionUpdatedAt>>>;
  Name?: Maybe<Array<Maybe<VehicleConnectionName>>>;
  Engine?: Maybe<Array<Maybe<VehicleConnectionEngine>>>;
  Body?: Maybe<Array<Maybe<VehicleConnectionBody>>>;
  Price?: Maybe<Array<Maybe<VehicleConnectionPrice>>>;
  EngineDescription?: Maybe<Array<Maybe<VehicleConnectionEngineDescription>>>;
  Gearbox?: Maybe<Array<Maybe<VehicleConnectionGearbox>>>;
  TopSpeed?: Maybe<Array<Maybe<VehicleConnectionTopSpeed>>>;
  Power?: Maybe<Array<Maybe<VehicleConnectionPower>>>;
  Torque?: Maybe<Array<Maybe<VehicleConnectionTorque>>>;
  Acceleration?: Maybe<Array<Maybe<VehicleConnectionAcceleration>>>;
  Image?: Maybe<Array<Maybe<VehicleConnectionImage>>>;
  TypeClass?: Maybe<Array<Maybe<VehicleConnectionTypeClass>>>;
  PageSlug?: Maybe<Array<Maybe<VehicleConnectionPageSlug>>>;
};

export type VehicleInput = {
  Name?: Maybe<Scalars['String']>;
  Engine?: Maybe<Scalars['String']>;
  Body?: Maybe<ENUM_VEHICLE_BODY>;
  Price?: Maybe<Scalars['Float']>;
  EngineDescription?: Maybe<Scalars['String']>;
  Gearbox?: Maybe<Scalars['String']>;
  TopSpeed?: Maybe<Scalars['String']>;
  Power?: Maybe<Scalars['String']>;
  Torque?: Maybe<Scalars['String']>;
  Acceleration?: Maybe<Scalars['String']>;
  Image?: Maybe<Scalars['ID']>;
  TypeClass?: Maybe<Scalars['String']>;
  PageSlug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Voucher = {
  __typename?: 'Voucher';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  Code?: Maybe<Scalars['String']>;
  Expiry?: Maybe<Scalars['Date']>;
  Booking?: Maybe<Booking>;
  CustomerFor?: Maybe<Customer>;
  CustomerBy?: Maybe<Customer>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  CourseType?: Maybe<CourseType>;
  r_customerForName?: Maybe<Scalars['String']>;
  r_customerByName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
};

export type VoucherAggregator = {
  __typename?: 'VoucherAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VoucherConnection = {
  __typename?: 'VoucherConnection';
  values?: Maybe<Array<Maybe<Voucher>>>;
  groupBy?: Maybe<VoucherGroupBy>;
  aggregate?: Maybe<VoucherAggregator>;
};

export type VoucherConnection_id = {
  __typename?: 'VoucherConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionBooking = {
  __typename?: 'VoucherConnectionBooking';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCode = {
  __typename?: 'VoucherConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCourseType = {
  __typename?: 'VoucherConnectionCourseType';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCreatedAt = {
  __typename?: 'VoucherConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCustomerBy = {
  __typename?: 'VoucherConnectionCustomerBy';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCustomerFor = {
  __typename?: 'VoucherConnectionCustomerFor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionExpiry = {
  __typename?: 'VoucherConnectionExpiry';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionHasPaid = {
  __typename?: 'VoucherConnectionHasPaid';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionId = {
  __typename?: 'VoucherConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionR_courseTypeName = {
  __typename?: 'VoucherConnectionR_courseTypeName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionR_customerByName = {
  __typename?: 'VoucherConnectionR_customerByName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionR_customerForName = {
  __typename?: 'VoucherConnectionR_customerForName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionUpdatedAt = {
  __typename?: 'VoucherConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherGroupBy = {
  __typename?: 'VoucherGroupBy';
  id?: Maybe<Array<Maybe<VoucherConnectionId>>>;
  _id?: Maybe<Array<Maybe<VoucherConnection_id>>>;
  createdAt?: Maybe<Array<Maybe<VoucherConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<VoucherConnectionUpdatedAt>>>;
  Code?: Maybe<Array<Maybe<VoucherConnectionCode>>>;
  Expiry?: Maybe<Array<Maybe<VoucherConnectionExpiry>>>;
  Booking?: Maybe<Array<Maybe<VoucherConnectionBooking>>>;
  CustomerFor?: Maybe<Array<Maybe<VoucherConnectionCustomerFor>>>;
  CustomerBy?: Maybe<Array<Maybe<VoucherConnectionCustomerBy>>>;
  HasPaid?: Maybe<Array<Maybe<VoucherConnectionHasPaid>>>;
  CourseType?: Maybe<Array<Maybe<VoucherConnectionCourseType>>>;
  r_customerForName?: Maybe<Array<Maybe<VoucherConnectionR_customerForName>>>;
  r_customerByName?: Maybe<Array<Maybe<VoucherConnectionR_customerByName>>>;
  r_courseTypeName?: Maybe<Array<Maybe<VoucherConnectionR_courseTypeName>>>;
};

export type VoucherInput = {
  Code?: Maybe<Scalars['String']>;
  Expiry?: Maybe<Scalars['Date']>;
  Booking?: Maybe<Scalars['ID']>;
  CustomerFor?: Maybe<Scalars['ID']>;
  CustomerBy?: Maybe<Scalars['ID']>;
  HasPaid?: Maybe<Scalars['Boolean']>;
  CourseType?: Maybe<Scalars['ID']>;
  r_customerForName?: Maybe<Scalars['String']>;
  r_customerByName?: Maybe<Scalars['String']>;
  r_courseTypeName?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};
